angular.module('dpw.components')
    .component('dpwLoading', {
        templateUrl: 'dpw-loading.html',
        bindings: {
            visible: '<'
        },
        controller: [function () {
        }]
    });
